import React, { useCallback, useMemo } from "react";
import toPlotly from "views/logic/aggregationbuilder/visualizations/Interpolation";
import { makeVisualization, retrieveChartData } from "views/components/aggregationbuilder/AggregationBuilder";
import AreaVisualizationConfig from "views/logic/aggregationbuilder/visualizations/AreaVisualizationConfig";
import useChartData from "views/components/visualizations/useChartData";
import useEvents from "views/components/visualizations/useEvents";
import useChartDataSettingsWithCustomUnits from "views/components/visualizations/hooks/useChartDataSettingsWithCustomUnits";
import useChartLayoutSettingsWithCustomUnits from "views/components/visualizations/hooks/useChartLayoutSettingsWithCustomUnits";
import usePlotOnClickPopover from "views/components/visualizations/hooks/usePlotOnClickPopover";
import scatterOnClickPopover from "views/components/visualizations/scatter/scatterOnClickPopover";
import XYPlot from "../XYPlot";
const AreaVisualization = makeVisualization(
  ({ config, data, effectiveTimerange, height, width }) => {
    const visualizationConfig = config.visualizationConfig || AreaVisualizationConfig.empty();
    const getChartDataSettingsWithCustomUnits = useChartDataSettingsWithCustomUnits({ config });
    const { interpolation = "linear" } = visualizationConfig;
    const chartGenerator = useCallback(
      ({ type, name, labels, values, originalName, fullPath }) => ({
        type,
        name,
        x: labels,
        y: values,
        fill: "tozeroy",
        line: { shape: toPlotly(interpolation), smoothing: 0.5, width: 1 },
        originalName,
        ...getChartDataSettingsWithCustomUnits({ name, fullPath, values })
      }),
      [getChartDataSettingsWithCustomUnits, interpolation]
    );
    const rows = useMemo(() => retrieveChartData(data), [data]);
    const _chartDataResult = useChartData(rows, {
      widgetConfig: config,
      chartType: "scatter",
      generator: chartGenerator
    });
    const { eventChartData, shapes } = useEvents(config, data.events);
    const chartDataResult = useMemo(
      () => eventChartData ? [..._chartDataResult, eventChartData] : _chartDataResult,
      [_chartDataResult, eventChartData]
    );
    const getChartLayoutSettingsWithCustomUnits = useChartLayoutSettingsWithCustomUnits({
      config,
      chartData: chartDataResult
    });
    const layout = useMemo(() => {
      var _a;
      const _layouts = getChartLayoutSettingsWithCustomUnits();
      if (shapes) {
        _layouts.shapes = [...(_a = _layouts.shapes) != null ? _a : [], ...shapes];
      }
      return _layouts;
    }, [shapes, getChartLayoutSettingsWithCustomUnits]);
    const { popover, initializeGraphDivRef, onChartClick } = usePlotOnClickPopover({
      ...scatterOnClickPopover,
      config
    });
    return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(
      XYPlot,
      {
        config,
        axisType: visualizationConfig.axisType,
        plotLayout: layout,
        effectiveTimerange,
        height,
        width,
        chartData: chartDataResult,
        onInitialized: initializeGraphDivRef,
        onClickMarker: onChartClick
      }
    ), popover);
  },
  "area"
);
export default AreaVisualization;
